import { render, staticRenderFns } from "./ProductPricing.vue?vue&type=template&id=c87ed382&scoped=true&"
import script from "./ProductPricing.vue?vue&type=script&lang=js&"
export * from "./ProductPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87ed382",
  null
  
)

export default component.exports